import React, { memo } from 'react';
import QuestionCircled from './icons/QuestionCircled';
import Wallet from './icons/Wallet';
import Phone from './icons/Phone';
import MapMark from './icons/MapMark';
import MapMarkSmall from './icons/MapMarkSmall';
import StarSmall from './icons/StarSmall';
import LangSmall from './icons/LangSmall';
import RewardSmall from './icons/RewardSmall';
import CircledArrowRight from './icons/CircledArrowRight';
import BigPregnacy from './icons/BigPregnacy';
import BigHeartCare from './icons/HeartCare';
import BigCallcenter from './icons/BigCallcenter';
import BigLactation from './icons/BigLactation';
import BigNewBornChild from './icons/BigNewBornChil';
import BigOther from './icons/BigOther';
import BigMagnifyingGlass from './icons/BigMagnifyingGlass';
import BigPlus from './icons/BigPlus';
import BigChat from './icons/BigChat';
import BigDocument from './icons/BigDocument';
import BigPeople from './icons/BigPeople';

const Icons = {
  QuestionMarkCircled: QuestionCircled,
  Wallet: Wallet,
  Phone: Phone,
  MapMark: MapMark,
  MapMarkSmall: MapMarkSmall,
  StarSmall: StarSmall,
  LangSmall: LangSmall,
  RewardSmall: RewardSmall,
  CircledArrowRight: CircledArrowRight,
  BigPregnacy: BigPregnacy,
  BigHeartCare: BigHeartCare,
  BigCallcenter: BigCallcenter,
  BigLactation: BigLactation,
  BigNewBornChild: BigNewBornChild,
  BigOther: BigOther,
  BigMagnifyingGlass: BigMagnifyingGlass,
  BigPlus: BigPlus,
  BigChat: BigChat,
  BigDocument: BigDocument,
  BigPeople: BigPeople,
};

/**
 * Render icons based on the provided icon name.
 *
 * @param {String} icon Name of the icon to render
 * @param {Number} size Size of the icon
 *
 * @returns {JSX.Element} Icon component
 */
const Icon = memo(({ icon, size }) => {
  const Component = Icons[icon];
  return <Component size={size} />;
});

export default Icon;
